import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, Users, MessageSquare, Phone } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
export function ReservationsPage() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    guests: '2',
    notes: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      console.log('Reservation submitted:', formState);
      setIsSubmitting(false);
      setIsSuccess(true);
      setFormState({
        name: '',
        email: '',
        phone: '',
        date: '',
        time: '',
        guests: '2',
        notes: ''
      });
    }, 1500);
  };
  const inputClasses = 'w-full bg-navy-900 border-2 border-navy-700 text-white px-4 py-3 focus:border-ocean-500 focus:outline-none focus:ring-1 focus:ring-ocean-500 transition-all duration-300 placeholder-gray-500 rounded-none';
  const labelClasses = 'block text-gold-500 font-heading font-bold text-sm uppercase tracking-wide mb-2';
  return <div className="min-h-screen bg-navy-900 text-white selection:bg-gold-500 selection:text-navy-900 flex flex-col" data-id="element-366">
      <Navigation data-id="element-367" />

      <main className="flex-grow pt-24 pb-16" data-id="element-368">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-369">
          <div className="text-center mb-12" data-id="element-370">
            <h1 className="font-heading font-bold text-4xl md:text-5xl text-white mb-4" data-id="element-371">
              Reserve a Table
            </h1>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-372">
              Enjoy great food and a welcoming atmosphere at The Dock Wall.
              Reserve your table in advance to ensure the perfect dining
              experience.
            </p>
          </div>

          <div className="bg-navy-800 p-8 md:p-12 border border-navy-700 shadow-2xl relative overflow-hidden mb-12" data-id="element-373">
            {/* Decorative accent */}
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-gold-500 via-ocean-500 to-gold-500" data-id="element-374" />

            {isSuccess ? <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} className="text-center py-12" data-id="element-375">
                <div className="w-16 h-16 bg-green-500/20 text-green-500 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-376">
                  <Calendar className="w-8 h-8" data-id="element-377" />
                </div>
                <h3 className="text-2xl font-heading font-bold text-white mb-4" data-id="element-378">
                  Reservation Request Received
                </h3>
                <p className="text-gray-300 mb-8" data-id="element-379">
                  Thank you for your reservation request. Our team will contact
                  you shortly to confirm your table.
                </p>
                <Button variant="primary" onClick={() => setIsSuccess(false)} data-id="element-380">
                  Make Another Reservation
                </Button>
              </motion.div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-381">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-382">
                  <div data-id="element-383">
                    <label htmlFor="name" className={labelClasses} data-id="element-384">
                      Full Name <span className="text-red-500" data-id="element-385">*</span>
                    </label>
                    <input type="text" id="name" name="name" required className={inputClasses} placeholder="John Doe" value={formState.name} onChange={handleChange} data-id="element-386" />
                  </div>
                  <div data-id="element-387">
                    <label htmlFor="phone" className={labelClasses} data-id="element-388">
                      Phone Number <span className="text-red-500" data-id="element-389">*</span>
                    </label>
                    <input type="tel" id="phone" name="phone" required className={inputClasses} placeholder="+353..." value={formState.phone} onChange={handleChange} data-id="element-390" />
                  </div>
                </div>

                <div data-id="element-391">
                  <label htmlFor="email" className={labelClasses} data-id="element-392">
                    Email Address <span className="text-red-500" data-id="element-393">*</span>
                  </label>
                  <input type="email" id="email" name="email" required className={inputClasses} placeholder="john@example.com" value={formState.email} onChange={handleChange} data-id="element-394" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-395">
                  <div data-id="element-396">
                    <label htmlFor="date" className={labelClasses} data-id="element-397">
                      <span className="flex items-center gap-2" data-id="element-398">
                        <Calendar className="w-4 h-4" data-id="element-399" /> Date
                      </span>
                    </label>
                    <input type="date" id="date" name="date" required className={inputClasses} value={formState.date} onChange={handleChange} data-id="element-400" />
                  </div>
                  <div data-id="element-401">
                    <label htmlFor="time" className={labelClasses} data-id="element-402">
                      <span className="flex items-center gap-2" data-id="element-403">
                        <Clock className="w-4 h-4" data-id="element-404" /> Time
                      </span>
                    </label>
                    <select id="time" name="time" required className={inputClasses} value={formState.time} onChange={handleChange} data-id="element-405">
                      <option value="" data-id="element-406">Select Time</option>
                      <option value="17:00" data-id="element-407">5:00 PM</option>
                      <option value="17:30" data-id="element-408">5:30 PM</option>
                      <option value="18:00" data-id="element-409">6:00 PM</option>
                      <option value="18:30" data-id="element-410">6:30 PM</option>
                      <option value="19:00" data-id="element-411">7:00 PM</option>
                      <option value="19:30" data-id="element-412">7:30 PM</option>
                      <option value="20:00" data-id="element-413">8:00 PM</option>
                      <option value="20:30" data-id="element-414">8:30 PM</option>
                    </select>
                  </div>
                  <div data-id="element-415">
                    <label htmlFor="guests" className={labelClasses} data-id="element-416">
                      <span className="flex items-center gap-2" data-id="element-417">
                        <Users className="w-4 h-4" data-id="element-418" /> Guests
                      </span>
                    </label>
                    <select id="guests" name="guests" className={inputClasses} value={formState.guests} onChange={handleChange} data-id="element-419">
                      {[1, 2, 3, 4, 5, 6, 7, 8].map(num => <option key={num} value={num} data-id="element-420">
                          {num} {num === 1 ? 'Guest' : 'Guests'}
                        </option>)}
                      <option value="9+" data-id="element-421">9+ (Call us)</option>
                    </select>
                  </div>
                </div>

                <div data-id="element-422">
                  <label htmlFor="notes" className={labelClasses} data-id="element-423">
                    <span className="flex items-center gap-2" data-id="element-424">
                      <MessageSquare className="w-4 h-4" data-id="element-425" /> Special Requests
                    </span>
                  </label>
                  <textarea id="notes" name="notes" rows={3} className={inputClasses} placeholder="Allergies, special occasions, seating preference..." value={formState.notes} onChange={handleChange} data-id="element-426" />
                </div>

                <div className="pt-4" data-id="element-427">
                  <Button type="submit" variant="primary" size="lg" className="w-full" disabled={isSubmitting} data-id="element-428">
                    {isSubmitting ? 'Sending Request...' : 'Confirm Reservation'}
                  </Button>
                </div>
              </form>}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-center md:text-left" data-id="element-429">
            <div className="bg-navy-800/50 p-6 border border-navy-700" data-id="element-430">
              <h3 className="font-heading font-bold text-xl text-white mb-2 flex items-center justify-center md:justify-start gap-2" data-id="element-431">
                <Phone className="w-5 h-5 text-gold-500" data-id="element-432" /> Alternative Booking
              </h3>
              <p className="text-gray-400 mb-2" data-id="element-433">Prefer to book by phone?</p>
              <a href="tel:+353873307277" className="text-ocean-500 font-bold hover:text-ocean-400 transition-colors text-lg" data-id="element-434">
                +353 87 330 7277
              </a>
            </div>
            <div className="bg-navy-800/50 p-6 border border-navy-700" data-id="element-435">
              <h3 className="font-heading font-bold text-xl text-white mb-2" data-id="element-436">
                Same-Day Reservations
              </h3>
              <p className="text-gray-400" data-id="element-437">
                For same-day reservations, please call us directly to ensure
                immediate confirmation.
              </p>
            </div>
          </div>
        </motion.div>
      </main>

      <Footer data-id="element-438" />
    </div>;
}